<template>
  <main>
    <div class="shadow"/>
    <div class="popup">
      <AppSubTitle v-text="'Поздравляем!'"/>
      <AppSubTitle v-text="scoresExtended.all"/>

      <ul>
        <template v-for="value in lodash.omit(scoresExtended, ['all'])">
          <li v-text="value"/>
        </template>
      </ul>

      <AppButton
        @click="$emit('nextGame')"
        v-text="'Ура!'"
        bold
      />
    </div>
  </main>
</template>


<script>
import _ from 'lodash';
import AppButton from '@/components/game/ui/AppButton';
import AppSubTitle from '@/components/game/ui/AppSubTitle';

export default {
  name: 'AppGame_ViewFinish',

  constants: {
    scoreTemplates: {
      all: '+{{num}} {{text}}',
      words: 'За слова: +{{num}} {{text}}',
      author: 'За автора: +{{num}} {{text}}',
      difficulty: 'За сложность: +{{num}} {{text}}',
      tipWords: 'Подсказки слов: {{num}} {{text}}',
      tipName: 'Подсказка названия: {{num}} {{text}}',
      speedCoefficient: 'Множитель скорости: x{{num}}',
    },
  },

  components: {
    AppButton,
    AppSubTitle,
  },

  props: {
    scores: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    lodash: _,
  }),

  computed: {
    scoresExtended() {
      return _.reduce(this.scores, (acc, score, key) => {
        if (!score) return acc;
        if (key.endsWith('Coefficient') && score === 1) return acc;
        return Object.assign(acc, { [key]: this.useTemplate(key, score) });
      }, {});
    },
  },

  methods: {
    useTemplate(templateId, score) {
      const template = _.get(this.$options, `constants.scoreTemplates[${templateId}]`, '');
      return template.replace('{{num}}', score).replace('{{text}}', this.numWord(score));
    },

    numWord(value, words = ['лайк', 'лайка', 'лайков']) {
      value = Math.abs(value) % 100;
      var num = value % 10;
      if(value > 10 && value < 20) return words[2];
      if(num > 1 && num < 5) return words[1];
      if(num == 1) return words[0];
      return words[2];
    },
  },
};
</script>


<style lang="scss" scoped>
main {
  align-items: center;
  justify-content: center;

  .shadow {    
    backdrop-filter: blur(3px);
    background-color: #0004;
    position: fixed;
    inset: 0;
    z-index: 2;
  }

  .popup {
    z-index: 2;
    color: var(--color-white);
    width: 100%;
    position: absolute;
    max-width: 400px;
    background: linear-gradient(90deg, var(--color-primary), var(--color-secondary));
    border-radius: 8px;
    margin-bottom: calc(64px + 8px);
    display: flex;
    font-family: Arial, Helvetica, sans-serif;
    flex-direction: column;
    align-items: center;
    padding: 32px 24px;
    gap: 12px;

    & > h2 {
      text-transform: inherit;
      line-height: 1;

      &:nth-of-type(1) {
        font-size: 20px;
      }
      &:nth-of-type(2) {
        font-size: 32px;
      }
    }

    ul {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      gap: 12px;

      li {
        font-weight: bold;
        line-height: 1.1;
      }
    }
  }
}
</style>